import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Button from '../../components/button';
import H1 from '../../components/h1';
import Select from '../../components/select';
import Spacer from '../../components/spacer';
import AppState from '../../store/appstate';
import Input from '../../components/input';

function Onboarding1() {
  const { t } = useTranslation('onboarding');
  const role = AppState.useState((s) => s.onboarding?.role);
  const accountName = AppState.useState((s) => s.onboarding?.accountName);

  const [showArtistInput, setShowArtistInput] = useState(false);
  const [selectedRolePlaceHolder, setSelectedRolePlaceHolder] = useState(false);

  const history = useHistory();

  useEffect(() => {
    if (role) {
      if (role === 'Label') {
        setShowArtistInput(true);
        setSelectedRolePlaceHolder('Label Name');
      } else {
        setShowArtistInput(false);
      }
    }
  }, [role]);

  return (
    <div className="container mx-auto">
      <div className="flex flex-col justify-center items-center text-white p-4 text-center min-h-screen-minus-footer">
        <H1>{t('onboarding:select-account-role')}</H1>
        <Spacer />
        <Select
          className="w-full lg:w-1/3 text-sentric-dark-gray"
          name="artist"
          placeholder={t('onboarding:select-role-placeholder')}
          value={role}
          onChange={(selected) => AppState.update((s) => {
            s.onboarding.role = selected;
          })}
          options={[
            { name: t('onboarding:_band'), value: 'Band' },
            { name: t('onboarding:_artist'), value: 'Artist' },
            { name: t('onboarding:_songwriter'), value: 'Songwriter' },
            { name: t('onboarding:_label'), value: 'Label' },
            { name: t('onboarding:_manager'), value: 'Manager' },
            { name: t('onboarding:_dj'), value: 'DJ' },
            { name: t('onboarding:_producer'), value: 'Producer' },
          ]}
        />
        {showArtistInput && (
          <div className="w-full lg:w-1/3">
            <Spacer />
            <Input
              placeholder={selectedRolePlaceHolder}
              value={accountName}
              onChange={(e) => AppState.update((s) => {
                s.onboarding.accountName = e.target.value;
              })}
            />
          </div>
        )}
        <Spacer />

        <div className="flex flex-row">
          <Button
            disabled={!role}
            onClick={() => history.push('/onboarding-2')}
          >
            {t('onboarding:next-step-button')}
          </Button>
        </div>
        <Spacer />
      </div>
    </div>
  );
}

export default Onboarding1;
